import axios from "axios";
import {TIMEOUTS} from "../../util/Constants";
import {getStationCode} from "../../network/NetworkUtil";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {
    ERROR_COUNT_METRIC,
    GLOBAL_METRIC_KEY,
    logErrorMetric,
    logOperationalMetric,
    MetricType,
    PICK_TAB_METRIC_KEY,
    RSWS_GET_AR_WORKSTATION_METRIC
} from "../../util/MetricUtil";
import {WORKSTATION_METRIC_SPANS, WORKSTATION_METRIC_TYPES} from "../../pickStatus/constants/Constants";
import {roundTo2Decimals} from "../../util/Util";
import {Logger} from "../../util/Logger";
import {API_METRIC_NAME} from "./apiMetricNames";
import {ACTIVE, LOGGED_OUT} from "../../util/EntityStatusManager";

/**
 * converts metrics data in API response to list of rows in UI for a selected time span
 **/
export function convertMetricsDataToUIModel(response, selectedSpan) {
    const metrics = response.metrics
    let dataColumns = {}
    let metricTypes = {};
    if (!Array.isArray(metrics) || metrics.length === 0){
        return [];
    }

    metrics.forEach(metricData => {
        const spanData = metricData.metricValues.filter((metricValues) => (metricValues.span === selectedSpan))
        if(spanData && spanData.length !== 0){
            dataColumns[metricData.metricName] = spanData[0].dataPoints;
            metricTypes[metricData.metricName] = spanData[0].dataType ? spanData[0].dataType : WORKSTATION_METRIC_TYPES.DEFAULT;
        }
        else{
            const fixedMetricData = metricData.metricValues.filter((metricValues) => (metricValues.span === WORKSTATION_METRIC_SPANS.none));
            if(fixedMetricData && fixedMetricData.length !== 0){
                dataColumns[metricData.metricName] = fixedMetricData[0].dataPoints;
                metricTypes[metricData.metricName] = fixedMetricData[0].dataType ? fixedMetricData[0].dataType : WORKSTATION_METRIC_TYPES.DEFAULT;
            }
            else {
                dataColumns[metricData.metricName] = {}
            }
        }
    })
    const metricNames = Object.keys(dataColumns);
    const stationIDs = dataColumns.PICK_RATE ? Object.keys(dataColumns.PICK_RATE) : Object.keys(dataColumns[metricNames[0]]);
    let rowList = []

    stationIDs.forEach(stationID => {
        let row = {};
        metricNames.forEach(metricName => {
            if(metricTypes[metricName] === WORKSTATION_METRIC_TYPES.DEFAULT) {
                row[metricName] = dataColumns[metricName][stationID] ? roundTo2Decimals(dataColumns[metricName][stationID]) : "";
            } else if (metricTypes[metricName] === WORKSTATION_METRIC_TYPES.DOUBLE) {
                row[metricName] = dataColumns[metricName][stationID] ? roundTo2Decimals(parseFloat(dataColumns[metricName][stationID][0])) : "";
            } else if (metricTypes[metricName] === WORKSTATION_METRIC_TYPES.STRING){
                row[metricName] = dataColumns[metricName][stationID] ? dataColumns[metricName][stationID] : "";
            } else {
                row[metricName] = "";
            }
        })
        row.stationID = stationID;

        if(!row[API_METRIC_NAME.stationStatus] && row.stationID !== "ALL"){
            row[API_METRIC_NAME.stationStatus] = LOGGED_OUT;
        } else if(row.stationID !== "ALL" && Array.isArray(row[API_METRIC_NAME.stationStatus])
            && row[API_METRIC_NAME.stationStatus].includes(ACTIVE)){
            row[API_METRIC_NAME.stationStatus] = ACTIVE;
        }

        rowList.push(row)
    })

    return rowList
}

const getWorkstationMetricsAllSpansFromResponse = (response) => {
    const intervals = [WORKSTATION_METRIC_SPANS.min15, WORKSTATION_METRIC_SPANS.min30, WORKSTATION_METRIC_SPANS.hour1, WORKSTATION_METRIC_SPANS.cumulative]
    let metrics = {}
    intervals.forEach(interval => {
        metrics[interval] = convertMetricsDataToUIModel(response, interval)
    })
    return metrics;
}

async function getMetricsFromAPI(baseUrl, stationCode, stationConfig) {
    const startTime = Date.now();
    try {
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        // date is calculated on the backend so it is not specified
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/ar/metrics/stationCode/" + stationCode,
                httpMethod: "get",
                processName: "routeStaging"
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            // date is calculated on the backend so it is not specified
            response = await api.get("/rsws/ar/metrics/stationCode/" + stationCode);
        }
        logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_GET_AR_WORKSTATION_METRIC, MetricType.SUCCESS);
        return response;
    } catch (error) {
        Logger.error("Exception in ARStationMetricsAPI.getMetricsFromAPI", error);
        logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_GET_AR_WORKSTATION_METRIC, MetricType.FAILED);
    }
    return null
}

async function getMetrics(dispatcher, filterDispatcher, stationConfig, baseUrl) {
    const stationCode = getStationCode();
    try {
        const response = await getMetricsFromAPI(baseUrl, stationCode, stationConfig);
        if(response) {
            const tableData = getWorkstationMetricsAllSpansFromResponse(response.data);
            dispatcher({ type: "RECEIVE_METRICS", data: tableData});
            filterDispatcher({type: "RECEIVE_FILTER_DATA", data: getFilterData(tableData[WORKSTATION_METRIC_SPANS.cumulative])})
        }
    }
    catch (error) {
        Logger.error("Exception in ARStationMetricsAPI.getMetrics", error);
        logErrorMetric(stationCode, GLOBAL_METRIC_KEY, ERROR_COUNT_METRIC);
    }
}

export function fetchARMetrics(dispatcher, filterDispatcher, stationConfig, baseUrl){
    getMetrics(dispatcher, filterDispatcher, stationConfig, baseUrl);
}

export function getFilterData(rowList) {
    const data = {
        pickWorkstations: new Set(),
    }
    rowList.forEach(row => {
        if (row.stationID) {
            data.pickWorkstations.add(row.stationID)
        }
    })
    return data;
}



// WEBPACK FOOTER //
// ./src/components/workstationMetrics/network/ARStationMetricsAPI.js